"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withWeightRegular = void 0;
var tslib_1 = require("tslib");
require("./Text_weight_regular.css");
var core_1 = require("@bem-react/core");
var react_1 = tslib_1.__importDefault(require("react"));
var Text_1 = require("../Text");
/**
 * Модификатор, отвечающий за насыщенность текста.
 * @param {ITextWeightRegularProps} props
 */
exports.withWeightRegular = core_1.withBemMod(Text_1.cnText(), { weight: 'regular' }, function (WrappedComponent) { return (function (_a) {
    var weight = _a.weight, props = tslib_1.__rest(_a, ["weight"]);
    return react_1.default.createElement(WrappedComponent, tslib_1.__assign({}, props));
}); });
